import * as React from "react";
const SvgFiBrandsAtlassian = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-atlassian_svg__a)">
      <path d="M7.134 11.081c-.364-.4-.91-.364-1.164.11L.074 22.98c-.218.473.109 1.02.619 1.02h8.188a.68.68 0 0 0 .619-.4c1.783-3.64.727-9.208-2.366-12.52M11.429.382c-3.275 5.204-3.057 10.99-.91 15.321 2.183 4.331 3.821 7.68 3.967 7.897.109.255.364.4.619.4h8.188c.509 0 .873-.546.619-1.019 0 0-11.027-22.053-11.318-22.599-.219-.509-.838-.509-1.165 0" />
    </g>
    <defs>
      <clipPath id="fi-brands-atlassian_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsAtlassian;
